module.exports = __webpack_public_path__ + "ACURA-logo.png";